import { useEffect } from "react";

function apiOrigin(): string {
    const base = process.env.REACT_APP_BASE_URL || "https://api.theplug.co/";
    return base.replace(/\/$/, "");
}

/**
 * Sends all visitors to the canonical Privacy Policy served by the API (Express + privacy.pug).
 */
const PrivacyPageRedirect = () => {
    useEffect(() => {
        window.location.replace(`${apiOrigin()}/privacy`);
    }, []);
    return null;
};

export default PrivacyPageRedirect;
